//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useCallback, useEffect, useContext } from "react";
import { CSVLink } from "react-csv";
import * as moment from "moment";
import { toast } from "react-toastify";

// custom pages
import { styles } from "./styles";
import report from "apis/Report/Report";
import { Earn, PromoEarn } from "./config/config";
import { toastCss, successCss } from "assets/styleJS/global";
import NoData from "components/Table/NoData";
import Loader from "components/Loader/Loader";
import Context from "context/context";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import {
  DatePicker,
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import CircularProgress from "@material-ui/core/CircularProgress";

// material-ui icons
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import {currencyFormat} from "helpers/dataFormat"

import { useTranslation } from 'react-i18next';
import { enUS, fr } from "date-fns/locale";
import {dateFormat} from "helpers/dataFormat";
// import { blockInvalidChar } from "helpers/blockInvalidChar";

const GlobalCss = withStyles({
  "@global": {
    " .MuiDialog-scrollPaper": {},
    ".MuiDialog-paperWidthSm": {
      overflow: "hidden",
      maxWidth: "none",
    },
    " .MuiDialog-paper ": {},
  },
})(() => null);

export default function EarnFunc(props) {
  const { state, dispatch } = useContext(Context);

  const { page, setDisableDropdown } = props;
  const { promoEarnAPI,promoList } = report();
  const classes = styles();

  const [selectedDate, handleDateChange] = useState(new Date());
  const [promotionList,setPromotionList] = useState([]);

  const { t, i18n } = useTranslation();
  const [states, setstates] = useState({
    columns: [],
    selectedColumns: [],
    selectedFields: [],
    selectedHeaders: [],
    dialog: false,
    data: [],
    response: false,
    startDate: null,
    endDate: null,
    dateApplied: false,
    filterColumn: "",
    filterValue: "",
    filterApplied: false,
    groupBy: "",
    groupByApplied: false,
    pLoading: false,
    eLoading: false,
    errorDialog: false,
    errorCount: "",
    dollarValue:0.005,
    multivalue:""
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const locale = i18n.language == 'fr' ? fr : enUS
  const blockInvalidChar = e => ['e', 'E', '-','+','ArrowUp', 'ArrowDown'].includes(e.key) && e.preventDefault();
  // setting checkboxes
  useEffect(() => {
    let label = PromoEarn?.columns?.map((c) => c.label);
    if(state?.userInfo?.loyalty_organization_name != 'Henry Schein Canada'){

    }
    setStates({ columns: label, selectedColumns: label });
    // handleGetPromo()
  }, []);

  useEffect(() => {
    if(states.startDate&&states.endDate && states.startDate !='Invalid Date' && states.endDate !='Invalid Date'){
      let date  = states.startDate
      handleGetPromo()
    }
    if(!states.startDate&&!states.endDate && states.startDate !='Invalid Date' && states.endDate !='Invalid Date'){
      handleGetPromo()

    }
 
  }, [states.startDate,states.endDate]);
  const handleGetPromo = async () => {
    try {
      let values
      if(states.startDate&&states.endDate && states.startDate !='Invalid Date' && states.endDate !='Invalid Date'){
        values = {
          startDate: moment(states.startDate).format("YYYY-MM-DD"),
          endDate: moment(states.endDate).format("YYYY-MM-DD"),
               };
    }
      
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await promoList(values);

      if (res) {
       setPromotionList(res?.data);
   
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  const promotion = promotionList.find(
    (promo) => promo.promotion_name === states?.filterColumn
  );
  const multiplier = promotion ? promotion.multiplier : null;

  const options = Array.from({ length: multiplier-1 }, (_, index) => index + 1 ) ;
  

  

  
  // Earn api func
  const handleGetBurn = async () => {
    try {
      setDisableDropdown(true);
      let selectedColumnKeys = [];

      let selectedObj = [];
      let selectedHeaders = [];



      setStates({
        selectedFields: PromoEarn.columns.map(c => c.key),
        selectedHeaders: PromoEarn.columns.map(c => c.label),
      });

      let values = {
        fields: PromoEarn.columns.map(c => c.key),
      };
      if (states.dateApplied) {
        values = {
          ...values,
          startDate: moment(states.startDate).format("MM/DD/YYYY"),
          endDate: moment(states.endDate).format("MM/DD/YYYY"),
        };
      }
      if (states.filterApplied) {
        values = {
          ...values,
          filterBy: { ['rule_id']: [states.filterColumn] },
        };
      }
      if (states.groupByApplied) {
        values = { ...values, groupBy: states.groupBy };
      }
      let res = await promoEarnAPI(values);
      if (res && res?.type === "ERROR") {
        dispatch({ type: "SET_REPORT_RES_COUNT", payload: 0 });
        setStates({
          pLoading: false,
          eLoading: false,
          errorDialog: true,
          errorCount: res?.count,
        });
        setDisableDropdown(false);
      }
      if (res && res?.data) {
        dispatch({ type: "SET_REPORT_RES_COUNT", payload: 0 });
        // console.log(res?.data,"resdate")
        let sumESA = 0  
        let sumPoints = 0  
        let sumbasePoints = 0  
        let sumPromoPoints = 0  
        let sumratio = 0  


        const roundedArray = res?.data?.map(item => {
          // Round the tier_ratio value to two decimal places
          const roundedRatio = Number(item.tier_ratio).toFixed(2)+ String.fromCharCode(8203);
          sumESA += item?.extended_sales_amount
          sumPoints += item?.points
          sumbasePoints += item?.base_points
          sumPromoPoints += item?.promo_points
          sumratio +=item?.tier_ratio
          return {...item, tier_ratio: roundedRatio,points:pointsFormat(item?.points),base_points:pointsFormat(item?.base_points),promo_points:pointsFormat(item?.promo_points)};
      });
      roundedArray.push({loyalty_id:res?.data?.length,extended_sales_amount:currencyFormat(sumESA,i18n?.language,state?.userInfo?.loyalty_organization_name),points:pointsFormat(sumPoints),base_points:pointsFormat(sumbasePoints),promo_points:pointsFormat(sumPromoPoints),tier_ratio:Number(sumratio/res?.data?.length).toFixed(2)+ String.fromCharCode(8203)})

       roundedArray.push({base_points:"Promo Points Cost",promo_points:currencyFormat(states.dollarValue * parseInt(sumPromoPoints),i18n?.language,state?.userInfo?.loyalty_organization_name)})

      roundedArray.push({})
      roundedArray.push({})
      roundedArray.push({})
      roundedArray.push({tier_ratio:`${states.filterColumn}`})

      roundedArray.push({tier_ratio:states.startDate?`(Results from: ${moment(states.startDate).format("MM/DD/YYYY")} - ${moment(states.endDate).format("MM/DD/YYYY")})`:''})

      roundedArray.push({customer_account_number:'Trans',extended_sales_amount:'Ttl Sales',points:'Ttl Points',base_points:'Base Pts',promo_points:'Promo Pts',tier_ratio:'Avg Rate',order_date:'Avg Pts Incr',rule_description:'Pts Cost Incr',type:'As % of Sales',product_code:'% Sales Lift',product_brand_name_code:states?.multivalue?`${states?.multivalue}x promo point`:'',order_id:states?.multivalue?`${states?.multivalue}x Pts Cost Incr`:''})



       roundedArray.push({customer_account_number:res?.data?.length,extended_sales_amount:currencyFormat(sumESA,i18n?.language,state?.userInfo?.loyalty_organization_name),points:pointsFormat(sumPoints),
        base_points:sumbasePoints?pointsFormat(sumbasePoints):'',promo_points:sumPromoPoints?pointsFormat(sumPromoPoints):'',tier_ratio:Number(sumratio/res?.data?.length).toFixed(2)+ String.fromCharCode(8203),order_date:Number((sumPoints/Number(sumratio/roundedArray.length).toFixed(2))/sumESA).toFixed(1),
        rule_description:sumPromoPoints?currencyFormat(states.dollarValue * parseInt(sumPromoPoints),i18n?.language,state?.userInfo?.loyalty_organization_name):'',type:sumPromoPoints?`${Number((((states.dollarValue * parseInt(sumPromoPoints))/sumESA)*100)).toFixed(2)+ String.fromCharCode(8203)}%`:'',product_brand_name_code:states?.multivalue?pointsFormat((sumPoints/multiplier)*states?.multivalue):'',order_id:states?.multivalue?currencyFormat(((sumPoints/multiplier)*states?.multivalue)*states.dollarValue):''})
 
        setStates({
          data: roundedArray,
          response: true,
          pLoading: false,
          eLoading: false,
        });
        setDisableDropdown(false);
        if (res.data.length === 0) {
          toast.success(t("No Data Found"), { toastId: "no-report-date" });
          return;
        }
        return true;
      }
    } catch (err) {
      console.log(err);
    }
  };
 

  const pointsFormat = (value) => {
    if (value) {
      var nfObject = new Intl.NumberFormat("en-US");
      var points = nfObject.format(value);
      return points;
    }
    return "";
  };

  const pointsDecimalFormat = (value) => {
    if (value) {
      var points = value.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return points;
    }
    return "";
  };

  

  

  // const dividedvalue = 

  return (
    <div>
      <GlobalCss />
      <div className={classes.headText}>
        {t('Select date range')}{" "}
        {states.dateApplied && (
          <React.Fragment>
            <span className={classes.appliedSpan}>
              <CheckCircleIcon />
            </span>
            <span
              className={classes.removeSpan}
              onClick={() => {
                setStates({
                  dateApplied: false,
                  startDate: null,
                  endDate: null,
                });
              }}
            >
              {t('Remove')}
            </span>
          </React.Fragment>
        )}
      </div>
      <div className={classes.inputsDiv}>
        <Grid container spacing={0}>
          <Grid item xs={12} md={3}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format={i18n.language == "en" ? "MM/dd/yyyy" : "dd/MM/yyyy"}
                margin="normal"
                label={t("Start Date")}
                id="date-picker-inline"
                className={classes.dateInput}
                value={states.startDate}
                maxDate={new Date()}
                onChange={(date) => {
                  if (moment(date).isAfter(states.endDate)) {
                    toast.error("Start date should be greater than End date.", {
                      toastId: "start-date-end-date",
                    });
                    return;
                  }
                  setStates({ startDate: date, dateApplied: true });
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                autoOk
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} md={3}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format={i18n.language == "en" ? "MM/dd/yyyy" : "dd/MM/yyyy"}
                margin="normal"
                label={t("End Date")}
                id="date-picker-inline2"
                className={classes.dateInput}
                value={states.endDate}
                maxDate={new Date()}
                onChange={(date) => {
                  if (moment(states.startDate).isAfter(date)) {
                    toast.error("Start date should be greater than End date.", {
                      toastId: "start-date-end-date",
                    });
                    return;
                  }
                  setStates({ endDate: date, dateApplied: true });
                  
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                autoOk
              />
            </MuiPickersUtilsProvider>
          </Grid>

          
        </Grid>
      </div>
      <Grid container spacing={0}>
      <div className={classes.headText}>
        {t('Filter value')}
        {states.filterApplied && (
          <React.Fragment>
            <span className={classes.appliedSpan}>
              {" "}
              <CheckCircleIcon />
            </span>
            <span
              className={classes.removeSpan}
              onClick={() => {
                setStates({
                  filterApplied: false,
                  filterColumn: "",
                  filterValue: "",
                });
              }}
            >
              {t('Remove')}
            </span>
          </React.Fragment>
        )}
      </div>
      <Grid container spacing={0} className={classes.inputsDiv}>
        <Grid item xs={12} md={3}>
          <TextField
            id={"filter-column"}
            label={t("Promotion Name")}
            select
            type={"text"}
            className={classes.filterInput}
            value={states.filterColumn}
            onChange={(e) => {
              // console.log( e.target.value)
              setStates({
                filterColumn: e.target.value,
                filterApplied: true,
                filterValue: "",
              });
            }}
          >
            {promotionList?.map((r, i) => (
              <MenuItem value={r?.promotion_name} key={i}>
                {t(r?.promotion_name)}
              </MenuItem>
            ))}
          </TextField>

          
        </Grid>

        
       
      </Grid>
      <div className={classes.headText}>
        {t('Supplier Responsibility')}
      </div>
      <Grid container spacing={0} className={classes.inputsDiv}>
        <Grid item xs={12} md={3}>
        <TextField
              id={"Dollar-value"}
              label={"Point Cost Value"}
              required
              onKeyDown={blockInvalidChar}
              type={"number"}
              onWheel={(e) => e.target.blur()}
              className={classes.filterInput}
              value={states.dollarValue}
              onChange={(e) => {
                setStates({
                  dollarValue: e.target.value,
                });
              }}
            ></TextField>
        </Grid>

        <Grid item xs={12} md={3}>
          <TextField
            id={"filter-column"}
            label={t(" Point Multiplier")}
            select
            
            type={"text"}
            className={classes.filterInput}
            value={states?.multivalue}
            onChange={(e) => {
              // console.log( e.target.value)
              setStates({
                multivalue: e.target.value,
                
              });
            }}
          >
             {options.map((option) => (
              <MenuItem value={option} key={option}>
                {t(option)}
              </MenuItem>
            ))}


           
          </TextField>

          
        </Grid>
       
      </Grid>
      </Grid>
     
     
      <div
        style={{ color: "gray", padding: 10 }}
      >{`*Max  file count can be exported ${pointsFormat(800000)}`}</div>
      <CSVLink
        id="csv"
        data={states.data}
        headers={PromoEarn.columns}
        filename={
          t(`Promotion Earn`) + " " + moment(new Date()).format("MM-DD-YYYY,h:mm A") + ".csv"
        }
        className={classes.CSVlink}
      
      />
      <div className={classes.exportAndPreview}>
        <Button
          className={classes.previewBtn}
          onClick={async () => {
           
            if (
              (states.startDate && !states.endDate) ||
              (!states.startDate && states.endDate)
            ) {
              toast.error(
                "Please select the both Start-date and End-date values",
                {
                  toastId: "empty-fields",
                }
              );
              return;
            }
            if (
              states.startDate?.toString() === "Invalid Date" &&
              states.endDate?.toString() === "Invalid Date"
            ) {
              toast.error("Invalid date.", {
                toastId: "invalid-date",
              });
              setStates({ startDate: new Date(), endDate: new Date() });
              return;
            } else if (states.startDate?.toString() === "Invalid Date") {
              toast.error("Invalid date.", {
                toastId: "invalid-s-date",
              });
              setStates({ startDate: new Date() });
              return;
            } else if (states.endDate?.toString() === "Invalid Date") {
              toast.error("Invalid date.", {
                toastId: "invalid-e-date",
              });
              setStates({ endDate: new Date() });
              return;
            }
            setStates({ response: false, data: [], pLoading: true });
            let res = await handleGetBurn();
            if (res) {
              setStates({ dialog: true });
            }
          }}
          disabled={states.pLoading || states.eLoading}
        >
          {states.pLoading ? (
            <React.Fragment>
              <CircularProgress
                style={{ height: 25, width: 25 }}
                variant="determinate"
                value={state.reportResCount}
              />{" "}
              &nbsp;
              <span style={{ color: "#305698", fontWeight: "bold" }}>
                {state.reportResCount == 0 ?
                  <div class="snippet">
                    <div class="stage">
                      <div class="dot-typing-p"></div>
                    </div>
                  </div> : `${state.reportResCount}%`}
              </span>
            </React.Fragment>
          ) : (
            t("Preview")
          )}
        </Button>
        <Button
          className={classes.exportBtn}
          onClick={async () => {
            if (states?.selectedColumns.length == 0) {
              toast.error("Select atleast one Field.", {
                toastId: "empty-fields",
              });
              return;
            }
  

            if (
              (states.startDate && !states.endDate) ||
              (!states.startDate && states.endDate)
            ) {
              toast.error(
                "Please select the both Start-date and End-date values",
                {
                  toastId: "empty-fields",
                }
              );
              return;
            }
            if (
              states.startDate?.toString() === "Invalid Date" &&
              states.endDate?.toString() === "Invalid Date"
            ) {
              toast.error("Invalid date.", {
                toastId: "invalid-date",
              });
              setStates({ startDate: new Date(), endDate: new Date() });
              return;
            } else if (states.startDate?.toString() === "Invalid Date") {
              toast.error("Invalid date.", {
                toastId: "invalid-s-date",
              });
              setStates({ startDate: new Date() });
              return;
            } else if (states.endDate?.toString() === "Invalid Date") {
              toast.error("Invalid date.", {
                toastId: "invalid-e-date",
              });
              setStates({ endDate: new Date() });
              return;
            }
            setStates({ response: false, data: [], eLoading: true });
            let res = await handleGetBurn();
            if (res) {
              let data = [];
              document.getElementById("csv").click();
            }
          }}
          disabled={states.eLoading || states.pLoading}
        >
          {states.eLoading ? (
            <React.Fragment>
              <CircularProgress
                style={{ height: 25, width: 25, color: "#fff" }}
                variant="determinate"
                value={state.reportResCount}
              />
              &nbsp;
              <span style={{ color: "#fff", fontWeight: "bold" }}>
                {state.reportResCount == 0 ?
                  <div class="snippet">
                    <div class="stage">
                      <div class="dot-typing-e"></div>
                    </div>
                  </div> : `${state.reportResCount}%`}
              </span>
            </React.Fragment>
          ) : (
            t("Export CSV")
          )}
        </Button>
        {(states.eLoading || states.pLoading) && <div style={{ color: 'red', marginLeft: 10 }}>*Please wait don't reload the page, system is processing</div>}
      </div>

      <Dialog
        onClose={() => {
          setStates({ dialog: false });
        }}
        aria-labelledby="simple-dialog-title"
        open={states.dialog}
      >
        <div className={classes.mainDiv}>
          <Grid container spacing={0}>
            <Grid item xs={12} className={classes.gridOne}>
              {t(page) + " " + t("Report")}
              <HighlightOffIcon
                className={classes.gridTwo}
                onClick={() => {
                  setStates({ dialog: false });
                }}
              />
            </Grid>
            <Grid item xs={12} className={classes.gridFive}>
              <span className={classes.gridThreeSpan}>{t("Generated Date")} : </span>
              <span>{dateFormat(moment(new Date()).format("MM-DD-YYYY"), i18n.language)}</span>
            </Grid>
          </Grid>
          {states.response ? (
            states.data && states.data.length > 0 ? (
              <TableContainer className={classes.tableContainer}>
                <Table
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  size={"medium"}
                  aria-label="enhanced table"
                >
                  <TableHead className={classes.tableHead}>
                    <TableRow>
                      {states.selectedColumns?.map((h, i) => (
                        <TableCell key={i} className={classes.tableHeading}>
                          <div
                            className={
                              (states.groupBy === "loyalty_id" &&
                                h === "Loyalty ID") ||
                                (states.groupBy ===
                                  "customer_billto_account_number" &&
                                  h == "Bill to Account ID") ||
                                (states.groupBy === "product_brand_name_code" &&
                                  h === "Brand Name Code") ||
                                (states.groupBy === "gl_cost_center_code" &&
                                  h === "Cost Center") ||
                                (states.groupBy === "product_primary_class_id" &&
                                  h === "Primary Class ID") ||
                                (states.groupBy === "transaction_type" &&
                                  h === "Transaction Type") ||
                                (states.groupBy === "label_class_code" &&
                                  h === "Label Class Code") ||
                                (states.groupBy === "order_id" &&
                                  h === "Order ID") 
                                //(states.groupBy === "customer_address_city_name" +","+
                                  // "customer_address_state_code"+","+"customer_address_country_code"
                                  //&& h === "Location") ||
                                //(states.groupBy === "Customer_Name" && h === "Practice Name") 
                                ? classes.groupByMarker
                                : classes.noDisplay
                            }
                          >{`(${t('Sort by')})`}</div>
                          <div>{t(h)}</div>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {states.data?.slice(0, 10)?.map((p, i) => (
                      <TableRow role="checkbox" tabIndex={-1} key={i}>
                        {states.selectedFields.map((s) => (
                          <TableCell align="left" className={classes.rowCell}>
                            {p?.[s] === true
                              ? "True"
                              : p?.[s] === false
                                ? "False"
                                : s === "extended_sales_amount"
                                  ? pointsDecimalFormat(p?.[s])
                                  : s === "points"
                                    ? pointsFormat(p?.[s])
                                    : t(p?.[s])}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <NoData />
            )
          ) : (
            <Loader Loading={!states?.response}></Loader>
          )}
        </div>
        {states.data && states.data.length > 0 && (
          <Grid container spacing={0}>
            <Grid xs={12} className={classes.gridFour}>
              <Button
                className={classes.previewBtn}
                onClick={() => {
                  setStates({ dialog: false });
                }}
              >
                {t('Cancel')}
              </Button>
              <Button
                className={classes.exportBtn}
                onClick={() => {
                  setStates({ dialog: false });
                  document.getElementById("csv").click();
                }}
              >
                {t('Export CSV')}
              </Button>
            </Grid>
          </Grid>
        )}
      </Dialog>

      {/* Error Dialog */}
      <Dialog
        aria-labelledby="simple-dialog-title"
        open={states?.errorDialog}
        style={{ fontFamily: "Segoe-ui" }}
      >
        <div className={classes.dialogParentDiv}>
          <div style={{ display: "flow-root" }}>
            <span style={{ float: "right" }}>
              <HighlightOffIcon
                style={{
                  verticalAlign: "-webkit-baseline-middle",
                  cursor: "pointer",
                  color: "red",
                }}
                onClick={() => {
                  setStates({ errorDialog: false });
                }}
              />
            </span>
          </div>

          <div className={classes.parentText}>
            {t('The date range has fetched')} {states.errorCount} {t('records.')} <br />
            {t('Due to Excel/CSV limitation we can only allow for 800,000 recordsfor export.')} <br />
            {t('Please add additional filters to limit your record count to less than 800,000.')}
          </div>
        </div>
      </Dialog>
    </div>
  );
}
